// extracted by mini-css-extract-plugin
export default {"arrowIcon":"Accordion_arrowIcon__010gS","openBackground":"Accordion_openBackground__+jMd9","textAnswer":"Accordion_textAnswer__IM9Bw"};